<template>
    <div class="my_header" :class="current > 0 ? 'my_header1' : ''">
        <div class="w1400 flex-row" style="justify-content: space-between;">
            <div class="clearfix">
                <a href="/" class="logo">
                    <img src="../../assets/img/lufei/ico_top_logo.png" class="logo1" alt="">
                    <img src="../../assets/img/lufei/ico_top_logo_black.png" class="logo2" alt="">
                </a>
            </div>
            <!-- {{ headList }} -->
            <div class="nav clearfix flex-row" style="align-items: center; height: 100%;">
                <el-menu :default-active="activePath" class="el-menu-demo" mode="horizontal"
                    :class="{ 'menu-scrolled': current }" @select="handleSelect">
                    <!-- menuArr -->
                    <el-menu-item v-for="(item, i) in menuArr" :key="item.menuId" :index="item.link"
                        v-if="!item.children" @click.native="elSubmenuClick(item.menuId, item)">
                        {{ item.menuName }}
                    </el-menu-item>
                    <el-submenu :index="item.link" v-else @click.native="elSubmenuClick(item.menuId, item)"
                        :class="{ 'is-active': activeIndex == item.menuId }">
                        <template slot="title">
                            <span style="display: inline-block;"> {{ item.menuName
                            }}</span>
                        </template>
                        <el-menu-item v-for="(card, j) in item.children" :key="card.menuId"
                            class="no-hover-effect ngs_class" :index="item.link"
                            @click.native.stop.prevent="elMenuItemClick(card)">{{
                                card.menuName
                            }}</el-menu-item>
                    </el-submenu>
                </el-menu>
                <span class="lang langActive langMargin">CH</span>
                <span class="langLine">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span class="lang">EN</span>
            </div>
        </div>
    </div>
</template>
<script>
import { listBjlfmenu } from "@/api/system/bjlfmenu"//读取北京鲁飞菜单列表
import { listBjlfproduct } from "@/api/system/bjlfproduct"//产品系列详情
import { mapState, mapMutations } from 'vuex'
import '../../assets/font/font.css'
export default {
    name: 'LufeidemoHeader',
    data() {
        return {
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10000,
                menuName: null,
                parentId: null,
                orderNum: null,
            },
            // current: 0,
            activePath: this.$route.path, // 1. 初始化时直接赋值为当前路由路径
            active: '',
            activeIndex: '1',
            menuArr: [
                // {
                //     label: '首页',
                //     link: '/home',
                //     val: '1',
                //     cardlist: []
                // },
                // {
                //     label: '产品中心',
                //     link: '/cpzx',
                //     val: '2',
                //     cardlist: [
                //         {
                //             label: 'AB产品',
                //             link: '/cpzx?cid=1',
                //             val: '1'
                //         },
                //         {
                //             label: 'AB产品',
                //             link: '/cpzx?cid=2',
                //             val: '2'
                //         },
                //         {
                //             label: 'AB产品',
                //             link: '/cpzx?cid=3',
                //             val: '3'
                //         }
                //     ]
                // },
                // {
                //     label: '解决方案',
                //     link: '/zhfa',
                //     val: '3',
                //     cardlist: [
                //         {
                //             label: 'AB门解决方案',
                //             link: '/cpzx?cid=1',
                //             val: '1'
                //         },
                //         {
                //             label: 'AB门解决方案',
                //             link: '/cpzx?cid=2',
                //             val: '2'
                //         },
                //         {
                //             label: 'AB门解决方案',
                //             link: '/cpzx?cid=3',
                //             val: '3'
                //         }
                //     ]
                // },
                // {
                //     label: '新闻中心',
                //     link: '/xwzx',
                //     val: '4',
                //     cardlist: [
                //         {
                //             label: '新闻中心',
                //             link: '/cpzx?cid=1',
                //             val: '1'
                //         },
                //         {
                //             label: '新闻中心',
                //             link: '/cpzx?cid=2',
                //             val: '2'
                //         },
                //         {
                //             label: '新闻中心',
                //             link: '/cpzx?cid=3',
                //             val: '3'
                //         }
                //     ]
                // },
                // {
                //     label: '关于我们',
                //     link: '/gywm',
                //     val: '5',
                //     cardlist: []
                // },
                // {
                //     label: '招贤纳士',
                //     link: '/swhz',
                //     val: '6',
                //     cardlist: []
                // }
            ]

        };
    },
    watch: {
        // '$store.state.lufei.productList': {
        //     handler(val) {
        //         this.headList[1].cardlist = val;
        //     },
        //     deep: true,
        // }
        // 2. 监听路由路径变化，同步更新 activePath
        '$route.path'(newPath) {
            this.activePath = newPath;
        },

    },
    computed: {
        ...mapState({
            current: state => state.lufei.current,
            Menuid: state => state.lufei.Menuid,
        }),
        // 计算当前路由的一级路径（用于激活一级菜单）
        // activeFirstLevelPath() {
        //     // 取路由匹配的第一个父级路径（即一级导航对应的路由）
        //     return this.$route.matched[0]?.path || '/';
        // }
        // activePath() {
        //     return this.$route.path;
        // }
    },
    mounted() {
        // this.headList[1].cardlist = this.$store.state.lufei.productList;
        // console.log(this.$route.path, 'mounted,Header组件')
        // 4. 组件挂载时，初始化 activePath 的值
        this.activePath = this.$route.path;
        this.$router.push({
            path: this.$route.path,
        })
        this.getList();
    },
    methods: {
        elMenuItemClick(item) {
            // console.log(item, 'aaaaaaaa')
            if (item.link.indexOf('/cpzx') !== -1) {
                listBjlfproduct({ menuId: item.menuId }).then(res => {
                    // console.log(res, '产品系列详情')
                    if (res.rows.length > 0) {
                        this.$router.push({
                            path: item.link,
                        });
                    } else {
                        this.$message.error('该系列暂无产品');
                    }
                })
            } else if (item.link.indexOf('/zhfa') !== -1) {
                this.$router.push({
                    path: item.link,
                });
            } else if (item.link.indexOf("/xwzx") !== -1) {
                this.$router.push({
                    path: item.link,
                });
            }
            // console.log('@@@@@@@@@@', item)
        },
        // 加载遮罩
        // loadingFn() {
        //     this.loading = this.$loading({
        //         lock: true,
        //         text: '数据加载中......',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.9)'
        //     });
        //     // setTimeout(() => {
        //     //     loading.close();
        //     // }, 2000);
        // },
        ...mapMutations('lufei', ['SET_Menuid']),
        /** 查询北京鲁飞菜单列表 */
        getList() {
            // console.log('sssssssssss')
            // this.loadingFn();
            listBjlfmenu(this.queryParams).then(response => {
                // console.log(response, '北京鲁飞菜单列表')
                // this.bjlfmenuList = this.handleTree(response.rows, "menuId");
                // console.log(this.handleTree(response.rows, "menuId"), '北京鲁飞菜单树形数据')
                this.menuArr = this.handleTree(response.rows, "menuId");
                // 获取第一个菜单id
                this.SET_Menuid(this.menuArr[0].menuId)
                // // this.bjlfmenuList = response.rows;
                // // console.log(this.bjlfmenuList, '北京鲁飞菜单数据')
                // this.total = response.total;
                // this.loading = false;
                //  this.handleTree(response.data, "menuId")
                // console.log(this.handleTree(response.rows, "menuId"), '北京鲁飞菜单树形数据')
                // setTimeout(() => {
                //     this.loading.close();
                // }, 1000);
            }).catch(error => {
                console.log(error, '北京鲁飞菜单列表失败')
                // setTimeout(() => {
                //     this.loading.close();
                // }, 1000);
            })
        },
        // 多级菜单中的一级菜单点击事件
        elSubmenuClick(i, item) {
            // console.log(item, 'aaaaaaa')
            // return 
            this.activeIndex = i;
            // console.log(i)
            if (item.children) {
                this.$router.push({
                    path: item.children[0].link,
                })
            } else {
                this.$router.push({
                    path: item.link,
                })
            }
            this.$forceUpdate(); // 强制刷新
            // 跳转到指定页面
            this.SET_Menuid(item.menuId)
            // console.log(this.menuArr, 'bbbbbbb')
        },
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
            this.activeIndex = key;
            // console.log(key, keyPath);
        },

    },


};
</script>
<style lang="less" scoped>
.logo1,
.logo2 {
    width: 178px;
    height: 46px;
}

::v-deep .el-menu-item {
    font-size: 18px !important;
}



// ::v-deep .el-menu--horizontal .el-menu .el-menu-item,
// .el-menu--horizontal .el-menu .el-submenu__title {
//     font-size: 12px;
// }

// ::v-deep .el-menu--horizontal .el-menu .el-menu-item.is-active,
// .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title {
//     font-size: 12px !important;
// }


::v-deep .el-menu {
    background: transparent;
    color: #ffff;
}

::v-deep .el-submenu__title {
    font-size: 18px;

}


::v-deep .el-menu--popup {
    margin-top: 60px !important;
}

::v-deep .el-menu.el-menu--horizontal {
    border: none;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #fff;
    color: #ffff;
}

::v-deep .el-menu-item:focus,
.el-menu-item:hover {
    background: transparent;
}

::v-deep .el-submenu__title:focus,
.el-submenu__title:hover {
    background: transparent;
}

::v-deep .el-submenu__title:hover {
    background: transparent;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
    color: #fff;
}

::v-deep .el-submenu__title i {
    color: #fff;
}

::v-deep.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: transparent;
}


::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #fff;
}

::v-deep .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: transparent;

}

::v-deep.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: transparent !important;

}

::v-deep.el-menu--horizontal>.el-menu-item {
    color: #fff;
}

::v-deep .el-menu--horizontal>.el-menu-item {
    background: transparent !important;
}

::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title:hover {
    background: transparent !important;
    // color: #fff;
}



// ::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
// .el-menu--horizontal .el-menu-item:not(.is-disabled) {
//     pointer-events: none !important;
// }

// ::v-deep .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
// .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
// .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
//     background: transparent !important;
// }

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: transparent !important;

}

::v-deep.el-menu-demo {
    height: 100% !important;
}

/* 滚动后的 hover/active 样式 */
::v-deep .el-menu-demo .menu-scrolled .el-menu-item:not(.is-disabled):hover,
::v-deep .el-menu-demo.menu-scrolled .el-menu-item.is-active {
    color: #000 !important;
    border-bottom: 2px solid #004CA6 !important;
    /* 黑色文字 */
    // background-color: rgba(0, 0, 0, 0.1) !important;
    /* 深色背景 */
}

::v-deep .el-menu-demo .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #004CA6;
}

/* 对子菜单的 hover 样式也做相应处理 */
::v-deep .el-menu-demo.menu-scrolled .el-submenu__title:hover {
    // background-color: rgba(0, 0, 0, 0.1) !important;
}

.langMargin {
    margin-left: 60px;
}

.lang {
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    padding-top: 10px;
    opacity: 0.4;

}

.langLine {
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    padding-top: 10px;
}

.langActive {
    opacity: 1;
}

.no-hover-effect {
    color: #000 !important;
}

.no-hover-effect:hover {
    color: #004CA6 !important;
}


.my_header {
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    /* background-color: red; */
    .logo {
        display: flex;
        align-items: center;
        width: 216px;
        height: 80px;

        .logo2 {
            display: none;
        }
    }

    ::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
        // color: inherit !important;
        color: #fff
    }

    ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title:hover {
        color: #fff !important
    }
}

.my_header1 {
    transition: all 0.6s;
    left: 0;
    top: 0;
    margin-left: 0;
    width: 100%;
    background: #ffffff;
    border-radius: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: 2px solid #004CA6;
    }

    ::v-deep .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
        // color: inherit !important;
        color: #000;
    }

    ::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
        color: #000;
    }

    ::v-deep .el-submenu__title i {
        color: #000;
    }

    ::v-deep .el-menu-item {
        color: #000;
    }

    ::v-deep .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: 2px solid #004CA6;
        color: #000;
    }

    ::v-deep .el-submenu.is-active .el-submenu__title {
        border-bottom: 2px solid #004CA6 !important;
    }

    ::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title:hover {
        color: #000 !important;
    }

    .lang {
        color: #000;
    }

    .logo1 {
        display: none !important;
    }

    .logo2 {
        display: block !important;
    }

    .one_a {
        color: #000 !important;
    }

    .active {
        .one_a {
            color: rgb(2, 167, 240) !important;
            font-weight: bold;
        }

        .one_a::after {
            transition: all 0.5s;
            width: 100%;
            background-color: rgb(2, 167, 240) !important;
        }
    }

    .langLine {
        color: #000;
    }
}

::v-deep .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #fff !important;
}


// 清除导航栏的padding  和margin
::v-deep .el-menu--horizontal>.el-menu-item {
    padding-top: 4px;
    padding: 0;
    margin-left: 60px;
    padding-top: 4px;

}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
    padding: 0;
    margin-left: 60px;

}
</style>